import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "What’s New in Freon 2.0",
description: "Discover the major improvements in Freon 2.0, including the redesigned Scoper, Flowbite-based web app, enhanced editor customization, smarter references, and updated tooling for Svelte 5.",
tags: [ "Freon 2.0", "release notes", "new features", "Scoper", "Flowbite", "Svelte 5", "projectional editor", "customization", "DSL development", "changelog"] ,
modifiedTime: "2025-11-07T17:20:18.610Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};